export default __webpack_public_path__ + "static/media/hide.d2bc0715.webp";